import { useEffect, useRef } from "react";

interface WaveDotsProps {
    nodes?: number; // Number of nodes in the standing wave
}

const WaveDots = ({ nodes = 1 }: WaveDotsProps) => {

    const canvasRef = useRef<HTMLCanvasElement>(null);

    useEffect(() => {
        const canvas = canvasRef.current;
        if (!canvas) return;

        const ctx = canvas.getContext('2d');
        if (!ctx) return;

        let width = canvas.width;
        let height = canvas.height;
        let time = 0;

        const dots: { x: number; y: number; radius: number; index: number }[] = [];

        // Size to the element rather than the window, so the backdrop fills the
        // frame's interior instead of spilling over its border.
        const resizeCanvas = () => {
            if (canvas) {
                canvas.width = canvas.clientWidth;
                canvas.height = canvas.clientHeight;
                width = canvas.width;
                height = canvas.height;
                ctx.translate(width / 2, height / 2); // improve rendering sharpness
                dots.length = 0; // clear existing dots
                const dotCount = 1000;
                for (let i = 0; i < dotCount; i++) {
                    let r = 400;
                    dots.push({
                        radius: r,
                        x: Math.sin((i / (dotCount - 1)) * Math.PI * 2) * r,
                        y: Math.cos((i / (dotCount - 1)) * Math.PI * 2) * r,
                        index: i
                    });
                }
            }
        }
        resizeCanvas();
        window.addEventListener('resize', resizeCanvas);

        let amplitude = 200;
        const animate = () => {
            if (!ctx) return;
            ctx.clearRect(-width / 2, -height / 2, width, height);
            time += 0.02;
            let currentNodes = nodes + Math.sin(time * 0.01) * 8 + 5;
            dots.forEach((dot, i) => {
                // Standing wave equation: y = A * sin(kx) * cos(ωt)
                // k = (n * π) / L where n is the number of nodes
                const k = (currentNodes * Math.PI) / (2 * Math.PI * dot.radius);
                const waveY = amplitude * Math.sin(k * dot.x);
                const waveX = amplitude * Math.sin(k * dot.y);

                ctx.beginPath();
                ctx.arc(waveX * 1.1, waveY * 1.1, 1, 0, Math.PI * 2);
                ctx.fillStyle = '#991515';
                ctx.fill();

                // draw a second arc slightly below the first to create a shadow effect
                ctx.beginPath();
                ctx.arc(-waveX, -waveY, 1, 0, Math.PI * 2);
                ctx.fillStyle = '#e9f8dc';
                ctx.fill();



                // draw two more that mirror the first two but offset in x by 10 pixels
                // ctx.beginPath();
                // ctx.arc(dot.x, centerY + yOffset - 10, 0.8, 0, Math.PI * 2);
                // ctx.fillStyle = '#e9f8dc';
                // ctx.fill();



            });

            // if (amplitude < 0) {
            //     amplitude = 0;
            // } else {
            //     amplitude -= 0.5;
            // }
            requestAnimationFrame(animate);
        }
        animate();

        return () => {
            window.removeEventListener('resize', resizeCanvas);
        }

    }, [nodes]);


    return (
        <canvas style={{ zIndex: 0, position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', opacity: 0.1, pointerEvents: 'none' }} id="canvas" ref={canvasRef}></canvas>
    );

}


export default WaveDots;